import { render, staticRenderFns } from "./InvE_Details.vue?vue&type=template&id=37c1156e"
import script from "./InvE_Details.vue?vue&type=script&lang=js"
export * from "./InvE_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports